import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const toDateOrNull = (value) => {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const SingleCalendarDateRangePicker = ({
  isClearable = true,
  className = '',
  holder = 'Select date range',
  valueStart = null,
  valueEnd = null,
  filters,
  setFilters,
}) => {
  const [dateRange, setDateRange] = useState([
    toDateOrNull(valueStart ?? filters?.startDate),
    toDateOrNull(valueEnd ?? filters?.endDate),
  ]);

  useEffect(() => {
    setDateRange([
      toDateOrNull(valueStart ?? filters?.startDate),
      toDateOrNull(valueEnd ?? filters?.endDate),
    ]);
  }, [valueStart, valueEnd, filters?.startDate, filters?.endDate]);

  const [startDate, endDate] = dateRange;

  const onChange = (update) => {
    setDateRange(update);

    if (setFilters && typeof setFilters === 'function') {
      setFilters((prev) => ({
        ...prev,
        startDate: update?.[0] ?? null,
        endDate: update?.[1] ?? null,
        page: 1,
      }));
    }
  };

  return (
    <DatePicker
      selectsRange
      startDate={startDate}
      endDate={endDate}
      onChange={onChange}
      isClearable={isClearable}
      placeholderText={holder}
      className={`w-full border border-gray-300 mt-1 rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-mts-blue-primary focus:border-mts-blue-primary ${className}`}
      dateFormat="yyyy/MM/dd"
      popperClassName="z-[9999]"
    />
  );
};

export default SingleCalendarDateRangePicker;
